export default {
  /*按钮*/
  bt:{
    search:"搜索",
    query:"查询",
    operation:"操作",
    add:"新增",
    edit:"修改",
    delete:"删除",
    down:"下载",
    export:"导出",
    upload:"上传",
    enable:"启用",
    disable:"禁用",
    copy:"复制",
  },
  /*公用字段或工具函数字段*/
  common:{
    startTime:"开始时间",
    endTime:"结束时间",
    creator:"创建人",
    updater:"更新人",
    createTime:"创建时间",
    updateTime:"更新时间",
    phone:"手机号",
    name:"姓名",
    email:"邮箱",
    idNumber:"身份证号码",
    status:"状态",
    remark:"备注",
  },
  /*用户追踪页面*/
  kscore:{
    month:"活动期数",
    profit:"收益",
    detail:"详情",
    symbol:'产品名称',
    direction:'买卖方向',
    openPrice:'开仓价格',
    closePrice:'平仓价格',
    createTime:'平仓时间',
    customer:'用户账号'
  },
  registerLog:{
    dataType:"数据类型",
    driverType:"设备类型",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    ipAddress:"IP所在地",
    href:"来源URL",
    referrer:"着陆页",
    directPhone:"推荐人手机号",
    phonePre:"手机区号",
    title:"性别",
    businessType:"业务组",
    ruleId:"短信规则id",
    register:"原始客户名单",
    agentCode:"代理人",
  },
  accountReward:{
    activeId:"活动ID",
    activeStatus:"活动状态",
    activeName:"活动名称",
    activeType:"活动类型",
    proposalNo:"提案号",
    beginDate:"活动开始时间",
    endDate:"活动结束时间",
    expDay:"有效期",
    proposalUser:"提案人",
    proposalDate:"提案时间",
    approvalUser:"审批人",
    approvalDate:"审批时间",
    proposalType:"提案类型",
    proposalStatus:"提案状态",
    applyProposal:"执行提案",
    cancelProposal:"取消提案",
    applySuccess:"执行成功",
    applyFail:"执行失败",
    choiceOne:"请选择一条提案",
    notSatisfiable:"提案不符合要求",
    downloadProActivity:"推荐赠金活动提案",
    excuteCustomerNumber:'会员账号',
    demo:'账户类型',
    levelType:'账户级别',
    mobilePhone:'电话',
    chineseName:'姓名',
    directPhone:'直接推荐人',
    directindirect:'直接/间接推荐人',
    indirectPhone:'间接推荐人',
    symbolType:'产品类型',
    execVolume:'交易笔数',
    complianceExecVolume:'客户交易手数/达标手数',
    complianceStatus:'达标状态',
    ctime:'达标时间',
    userCreateDate:'开户时间',
    activeTime:'激活时间',
    downloadEffectiveCustomer:'有效客户记录',
    downloadActivity:'交易返利活动',
    downloadActivity0:'推荐赠金活动',
    acitveDate:"活动时间",
    hierarchy:"层级设置",
    product:"推荐赠金设置",
    approve:"审批",
    to:"至",
    Reward:"奖励",
    time:"倍",
    condition:"条件设置",
    me:"客户",
    direct:"直接推荐",
    indirect:"间接推荐",
    quantity:"交易手数要求",
    tradeConfig:"返利交易配置"
  },
  rewardTradeDetails:{
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算账号手机号',
    currentChineseName:'结算账号姓名',
    excuteCustomerNumber:'客户交易账号',
    mobilePhone:'客户手机号',
    demo:'账户类型',
    levelType:'账户级别',
    symbolType:'产品类型',
    symbol:'产品',
    orderid:'持仓号',
    execVolume:'交易笔数',
    relationType:'奖励类型',
    directPhone:'直接推荐人',
    indirectPhone:'间接推荐人',
    currentRebete:'金额',
    ctime:'结算时间',
    downloadTradeDetails:'奖励明细记录',
  },
  rewardDealList:{
    createDate:'结算时间',
    currentCustomerNumber:'结算账号',
    currentMobilePhone:'结算手机号',
    currentChineseName:'结算客户姓名',
    customerStatus:'账户状态',
    currentRebete:'奖励金额',
    correctionRebete:'调整金额',
    finalRebete:'最终返利',
    proposalStatus:'状态',
    updateUser:'修改人',
    updateDate:'修改时间',
    approvalUser:'审批人',
    approvedDate:'审批时间',
    remark:'备注(拒绝原因)',
    confirmSubmit:'确认提交',
    confirmSuccess:"提交成功",
    confirmFail:"提交失败",
    cancel:'取消',
    confirm:'确定',
    cancelProposal:'取消提案',
    refuse:'拒绝提案',
    apply:'审批',
    reason:'原因',
    limit:'额度调整表',
    refuseProposal:'拒绝',
    downloadLimit:'下载额度调整表',
    refId:"发放奖励单号",
    approval:"确认审批",
  },
  relationList:{
    customerRelation:'用户推荐关系',
    customerRelationPro:'用户推荐关系提案',
    customerNum:'交易账号',
    mobilePhone:'手机号码',
    userName:'姓名',
    userLevel:'账户级别',
    createDate:'开户日期',
    activeTime:'激活时间',
    newdirectPhone:'直接推荐人',
    remark:'备注',
    customerNumber:'会员账号',
    phone:'电话',
    direct:'直接/间接推荐人',
    matchType:'推荐关系',
    activeStatus:'激活状态',
    demoCustomerNum:'模拟账号',
    directNumber:'直接推荐人账号',
    directPhone:'直接推荐人手机',
    indirectNumber:'间接推荐人账号',
    indirectPhone:'间接推荐人手机',
    reStatus:'匹配结果',
    proposalUser:'提案人',
    proposalDate:'提案时间',
    approvalUser:'审批人',
    approvalDate:'审批时间',
    applyProposal:"执行提案",
    cancelProposal:'取消提案',
    beginDate:'开户开始时间',
    endDate:'开户结束时间',
    proposalStatus:'提案状态',
    proposalNo:'提案号',
    relationOpenUrl:"客户推荐链接查询",
    relationCount:"推荐人数",
    relationStandardCount:"推荐达标人数",
    nationality:'国籍',
  },
  faceConfig:{
      deleteSuccess:'删除成功!',
      updateSuccess:'修改成功!',
      code:'通道编码',
      name:'通道名称',
      type:'验证类型',
      thirdParty:'第三方接口',
      cost:'费用',
      status:'状态',
      remark:'备注',
      verifyCode:'厂家通道',
      verifyType:'验证类型',
      verifyTypeCN:'验证类型中文',
      describe:'验证描述',
      device:'平台类型',
      channel: '渠道名称',
      version: '版本号',
      switchCode: '通道切换',
      faceStatus: '人脸控制',
      createDate : '创建时间',
      createUser: '创建人',
      updateUser: '修改人',
      updateDate: '修改时间',
      submitSuccess:'操作成功',
      faceRecord:'验证记录',
      chineseName: '姓名',
      card: '身份证',
      phone: '手机号',
      recordDate: '记录时间',
      channelName : '通道名称',
      result: '比对结果',
      resultParam: '查询输出',
      count: '使用次数',
      successCount: '成功次数',
      artificialCount: '人工调用成功次数',
      systemCount: '系统调用成功次数',
  },
  creditLevel:{
     updateList:'信用等级修改列表',
     journal:'修改日志',
     batchImport:'批量导入',
     uploadTip:'将文件拖到此处，或',
     uploadTip1:'点击上传',
     uploadTip2:'只能上传xlsx文件，且不超过10M',
     uploadSuc:'文件上传成功',
     uploadFail:'文件上传失败',
     downTemplate:'下载模板',
     uploadFile:'立即上传',
     batchUpdate:'批量修改',
     customerNo: '会员账号',
     pkey: 'P标签',
     creditLevelOld: '修改前的信用等级',
     creditLevelOriginal: '当前用户信用等级',
     creditLevel:'信用等级',
     remark:'备注',
     createDate :'创建时间',
     createUser: '创建人',
     updateUser: '修改人',
     updateDate: '修改时间',
  },
  rebateComponents:{
    customerNumber:'交易账号',
    subtotal:'小计',
    total:'总计',
    tradeLogList:'返利明细记录详情',
    cancel:'取消',
    confirm:'确认',
    symbolType:'产品类型',
    displayName:'产品',
    orderId:'持仓号',
    execVolume:'交易手数',
    execTime:'交易时间',
    rebateAmount:'返利金额',
    activeName:'活动名称',
    activity:'活动时间',
    activeId:'活动ID',
    effective:'有效客户条件设置',
    tips:'新客户开户和激活时间必须在该活动期限内',
    beginDate: "开始时间",
    endDate: "结束时间",
    expDate: "有效期起始日",
    expDay: "有效期",
    productType: "产品类型",
    me: "客户",
    direct: "直接推荐",
    indirect: "间接推荐",
    quantity: "交易笔数要求",
    highAmount:'最高奖励金额',
    highAmount2:'新客户最高贡献返利',
    highPoint:'客户推荐累计获得最高返利',
    add:'新增',
    update:'修改',
    dollar:'美元',
    day:'天',
    activeTime:'激活日期',
    reward:'推荐赠金设置',
    rebate:'交易返利设置',
    addCondition:'添加条件',
    min:'迷你',
    std:'标准',
    vip:'铂金',
    to:'至',
    all:'全部',

  },
  risk:{
    name:"网关名称",
    baseSetting:"基础用户配置",
    specialSetting:"特定用户配置",
    ipSetting:"ip规则配置",
    addBaseSetting:"新增规则用户群",
    addspecialSetting:"新增特定用户群",
    settingTpye:"配置类型",
    userType:"用户群体",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    limitSetting:"限制规则",
  },
  registervalidate:{
    customerNo:"账号",
    registerType:"开户类型",
    target:"标签",
    creditTunnel2:"征信通道2",
    creditTunnel3:"征信通道3",
    validateStatus2:"二元素验证状态",
    validateStatus3:"三元素验证状态",
    registerStatus:"开户状态",
    channel:"渠道来源",
    kycResult:"kyc验证结果",
    personMarkTunnel:"征信诉讼通道",
    personMarkResult:"征信诉讼验证结果",
    creditLoanTunnel:"征信逾期通道",
    creditLoanResult:"征信逾期验证结果",
  },
  tracker:{
    customerNo:"用户账号",
    openStartTime:"开户开始时间",
    openEndTime:"开户结束时间",
    activeStartTime:"激活开始时间",
    activeEndTime:"激活结束时间",
    userType:"账号类型",
    isActive:"激活状态",
    isShow:"列段显示/隐藏",
    day:"当天激活",
    week:"当周激活",
    month:"当月激活",
    reset:"重置",
    businessType:"业务组",
    relatedAccount:"关联账号",
    levelType:"账号级别",
    userAge:"年龄",
    gender:"性别",
    birthday:"出生日期",
    ctime:"开户日期",
    pkey:"P标签",
    nkey:"N标签",
    creditLevel:"信用等级",
    href:"来源url",
    utmSource:"来源",
    utmMedium:"媒介",
    utmCampaign:"广告系列",
    utmContent:"广告组",
    utmTerm:"关键字",
    referrer:"着陆页",
    channel:"开户来源",
    activeTime:"激活时间",
    ipAddress:"IP所在地",
    userAgent:"浏览器",
    checkStatus:"IVI验证状态",
    arbitrageurTags:"IVI验证标记",
    directPhone:"推荐人手机号",
    tracker:"用户追踪",
    team:"所属团队",
    countryCode:"开户国籍",
    mediaSource:"AF_来源",
    campaign:"AF_广告系列",
    afChannel:"AF_渠道",
    afPrt:"af_partner",
    installTime:"安装时间"
  },
  activeTemplate:{
    type:"活动类型",
    url:"发布域名",
    detail:"模块模板",
    field:"广告属性",
    fieldTitle:"属性名称",
    fieldField:"属性编码",
    fieldType:"属性类型",
    text:"文字",
    img:"图片",
    title:"模板标题",
    activeTime:"活动时间",
    author:"发布人",
    editor:"富文本",
    textarea:"文本域",
    copy:"复制",
    modelField:"模块字段"
  },
  advertising:{
    key: "键",
    value: "值",
    type: "类型",
    createTime:"创建时间",
    updateTime:"更新时间",
    name:"广告名称",
    platform:"应用平台",
    term:"有效期",
    accountType:"账户类型",
    isActive:"激活状态",
    userLevel:"账户级别",
    aboutType:"转换度",
    position:"广告位置",
    positionType:"广告类型(1:'图片',2:'文字')",
    channel:"渠道",
    language:'语言',
    adverInfo:"跳转链接",
    startTime:"开始时间",
    endTime:"结束时间",
    status:"状态",
    carapace:"马甲包",
    time:"生效",
    param:"适用用户",
    url:"上传图片",
    title:"标题",
    preinstall:"活动详情",
    address:"地址",
    content:"内容",
    sort:"排序",
    simulation:"模拟",
    real:"真实",
    demoCaseReal:"真实模拟转换",
    nationality:"国籍",
  },
  analy:{
    dayActive:"当日实时激活数",
    dayReal:"当日真实开户",
    dayDemo:"当日模拟开户",
    dayRealDemo:"当日真实+模拟开户",
    in:"其中",
    dayRealActive:"当天开户并激活数",
    weekActiveCount:"最近7天激活数",
    weekRealCount:"最近7天真实开户数",
    weekDemoCount:"最近7天模拟开户数",
    weekRealDemoCount:"最近7天真实+模拟开户数",
    realCount:"真实开户数",
    demoCount:"模拟开户数",
    realDemoCount:"真实+模拟开户数",
    averCount:"工作日平均线",
    week0:"星期日",
    week1:"星期一",
    week2:"星期二",
    week3:"星期三",
    week4:"星期四",
    week5:"星期五",
    week6:"星期六",
    dayActiveRate:"当日实时激活来源渠道占比",
    dayRealRate:"当日实时真实开户来源渠道占比",
    dayDemoRate:"当日实时模拟开户来渠道占比",
    dayRealDemoRate:"当日实时真实+模拟来源渠道占比",
    dayRealCount:"当日实时真实开户数",
    dayDemoCount:"当日实时模拟开户数",
    dayRealDemoCount:"当日实时+模拟真实开户数",
    today:"今天",
    yesterday:"昨天",
    activeCount:"激活数",
  },
  smsType:{
    device:"页面端",
    type:"验证码方式",
    updateTime:"修改时间",
    modify:"切换方式"
  },
  currencySymbol:{
    symbol:"产品名称",
    lang:"语言",
    currency:"数量交易单位",
    time:"发行时间",
    total:"发行总量",
    uccnUrl:"官网",
    whiteUrl:"白皮书",
    detail:"介绍",
    updateTime:"更新时间"
  },
  country:{
    code: "国家编码",
    nameCn: "国家中文名称",
    nameEn: "国家英文名称",
    mobilePhonePrefix: "手机区号",
    sort: "排序(大->小)",
  },
  team:{
    name: "团队名称",
    country: "国家（多个用,隔开）",
    utmSource: "来源（多个用,隔开）",
    utmMedium: "媒介（多个用,隔开）",
  },
  knowledge:{
    type: "类别",
    lang: "语言",
    title: "标题",
    sort: "排序",
    url: "详情地址",
    detail: "详情",
  },
  optional:{
    iCodeId: "code",
    symbol: "产品编码",
    platform: "平台",
    businessType: "业务组",
    accountNo: "账号",
    account: "用户",
    createTime: "创建时间",
    channel: "渠道",
  },
  relationAnaly:{
    time:"统计月份",
    customerNumber:"被推荐人Id",
    inviteTotal:"所有推荐人数",
    inviteMonthTotal:"当月推荐人数",
    tradeTotal:"所有推荐人交易手数",
    tradeMonthTotal:"当月推荐人交易手数",
    year:"统计年",
    month:"月",
    relationAnaly:"推荐数据",
    monthTotal:"当月推荐总计",
    allTotal:"累积推荐总计",
    people:"人",
    efficientRelation:"有效推荐",
    trade:"累积交易",
    volume:"手数",
    ctime:"创建时间",
    activeTime:"激活时间",
    customerDetail:"推荐人详情",
    tradeDetail:"交易详情",
  },
  operations:{
    totalMem: "总客户数（人）",
    tradeTime: "交易次数（次）",
    sud: "客户提款额（SUD）",
    usd: "送出赠金额（USD）",
  },
  coin:{
    depthQtyDigitsLength: "深度行情交易量小数点位数",
    depthPriceDigitsLength: "深度行情价格小数点位数",
    depthQtyMin: "深度行情交易量最小值",
    code: "产品标识代码",
    symbol: "产品标识",
    status: "产品状态",
    ip: "服务器IP",
    depthPercentPrice: "深度行情交易价格百分比",
    depthPercentQty: "深度行情交易量百分比",
    tradeQtyMin:"交易量最小值",
    depthQtyRandomTimes:"深度行情成交量倍数(间隔符号|,:—_)",
    tradeQtyRandomTimes:"交易记录量倍数(间隔符号|,:—_)"
  },
  socialMedia: {
    common: {
      id: "ID",
      createdAt: "创建时间",
      updatedAt: "更新时间",
      createdBy: "创建用戶",
      updatedBy: "更新用戶",
      option: "请选择",
      undefined: "未定义",
      empty: "无"
    },
    message: {
      invalid: "无效操作",
      success: "请求成功",
      fail: "请求失败",
      unknown: "未知错误",
      duplicate: "与已有数据重复",
      channelNotEmpty: "渠道不能为空"
    },
    platform: {
      form: {
        name: {
          label: "平台名称",
          placeholder: "平台名称",
        }
      },
      table: {
        platform: "社交平台名称",
        image: "社交平台图标"
      },
      modal: {
        platform: {
          label: "平台名称",
          placeholder: "请输入平台名称",
        },
        image: {
          label: "平台图标",
          placeholder: "平台图标",
        }
      }
    },
    channel: {
      form: {
        name: {
          label: "渠道名称",
          placeholder: "渠道名称"
        },
        code: {
          label: "渠道代码",
          placeholder: "渠道代码"
        },
        system: {
          label: "系统类型",
          placeholder: "不限系统类型"
        }
      },
      table: {
        channel: "渠道名称",
        code: "渠道代码",
        system: "系统类型",
      },
      modal: {
        channel: {
          label: "渠道名称",
          placeholder: "请输入渠道名称",
        },
        code: {
          label: "渠道代码",
          placeholder: "请输入渠道代码"
        },
        system: {
          label: "系统类型",
          placeholder: "系统类型"
        },
      }
    },
    account: {
      form: {
        channel: {
          label: "渠道名称",
          placeholder: "渠道名称"
        },
        platform: {
          label: "社交平台",
          placeholder: "社交平台"
        },
        system: {
          label: "系统类型",
          placeholder: "不限系统类型"
        },
        status: {
          label: "状态",
          placeholder: "不限状态"
        },
        fromTime: {
          label: "从",
          placeholder: "创建时间"
        },
        toTime: {
          label: "至",
          placeholder: "创建时间"
        }
      },
      table: {
        sort: "排序",
        platform: "社交平台",
        url: "URL",
        web: "WEB渠道",
        m: "M渠道",
        app: "APP渠道",
        status: "状态"
      },
      modal: {
        platform: {
          label: "社交平台",
          placeholder: "请选择社交平台"
        },
        url: {
          label: "URL",
          placeholder: "请输入社交平台账号URL"
        },
        web: {
          label: "WEB渠道",
          placeholder: "web"
        },
        m: {
          label: "M渠道",
          placeholder: "m"
        },
        app: {
          label: "APP渠道",
          placeholder: "app"
        },
        sort: {
          label: "排序",
          placeholder: "999"
        },
        status: {
          label: "状态",
          placeholder: "状态"
        }
      }
    }
  }
};


